import { create } from 'zustand';

type ModuleStore = {
  moduleId: string | null;
  setModuleId: (moduleId: string) => void;
};

export const useModuleStore = create<ModuleStore>((set) => ({
  moduleId: null,
  setModuleId: (moduleId: string) => set({ moduleId }),
}));
